(function () {
    if (customElements.get('sticky-add-to-cart')) return;
    
    class StickyAddToCart extends HTMLElement {
        connectedCallback() {
            this.sectionId = this.dataset.sectionId;
            this.formId = this.dataset.formId;
            
            this.realForm = document.getElementById(this.formId);
            this.realSubmitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
            this.realSpinner = this.realSubmitButton ? this.realSubmitButton.querySelector('.loading-overlay__spinner') : null;
            this.realPriceWrapper = document.getElementById(`price-${this.sectionId}`);
            
            this.stickyButton = this.querySelector('.sticky-atc__submit');
            this.stickyButtonText = this.querySelector('.sticky-atc__submit-text');
            this.stickySpinner = this.querySelector('.loading-overlay__spinner');
            this.stickyPrice = this.querySelector('.sticky-atc__price');

            this.selectColorPlaceholder = document.querySelector('.select-color-placeholder');

            this.stickyATCBarBtnPlaceholder = document.querySelector('.sticky-placeholder__select-color-btn');
            this.variantWrapper = document.querySelector('variant-selects');
            
            if (!this.realForm || !this.realSubmitButton) return;
            
            this.stickyButton.addEventListener('click', this.handleClick.bind(this));
            
            this.setupVisibilityObserver();
            this.setupStateObserver();
            this.setupPriceObserver();

            this.scrollToColors();
        }

        scrollToColors() {
            if (this.stickyATCBarBtnPlaceholder) {
            this.stickyATCBarBtnPlaceholder.addEventListener('click', () => {
                if (!this.isInViewport(this.variantWrapper)) {
                this.variantWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                
            });
            }

        }

        isInViewport(el) {
            var rect = el.getBoundingClientRect();
            return rect.top >= 0 && rect.bottom <= window.innerHeight;
        }
        
        handleClick(event) {
            event.preventDefault();
            const isDisabled =
            this.realSubmitButton.hasAttribute('disabled') ||
            this.realSubmitButton.getAttribute('aria-disabled') === 'true';
            if (isDisabled) return;
            
            // Same click path as the real button  cart fetch, loading state,
            // error handling and cart drawer/redirect all behave identically.
            this.realSubmitButton.click();
        }
        
        setupVisibilityObserver() {
            this.visibilityObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                        this.classList.toggle('sticky-atc--visible', scrolledPast);
                    });
                },
                { threshold: 0 }
            );
            // this.visibilityObserver.observe(this.realSubmitButton);

            if (this.realSubmitButton) {
                this.visibilityObserver.observe(this.realSubmitButton);
            }

            if (this.selectColorPlaceholder) {
                this.visibilityObserver.observe(this.selectColorPlaceholder);
            }
        }
        
        setupStateObserver() {
            this.syncButtonState();
            this.stateObserver = new MutationObserver(() => this.syncButtonState());
            this.stateObserver.observe(this.realSubmitButton, {
                attributes: true,
                attributeFilter: ['disabled', 'aria-disabled', 'class'],
                childList: true,
                subtree: true,
                characterData: true,
            });
        }
        
        syncButtonState() {
            const isDisabled =
            this.realSubmitButton.hasAttribute('disabled') ||
            this.realSubmitButton.getAttribute('aria-disabled') === 'true';
            
            this.stickyButton.disabled = isDisabled;
            this.stickyButton.classList.toggle('loading', this.realSubmitButton.classList.contains('loading'));
            
            const realText = this.realSubmitButton.querySelector('span');
            if (realText && this.stickyButtonText) {
                this.stickyButtonText.textContent = realText.textContent.trim();
            }
            
            // Query fresh each time instead of caching at connectedCallback 
            // corrected selector to match Dawn's loading-spinner.liquid markup.
            const realSpinner = this.realSubmitButton.querySelector('.loading__spinner');
            const stickySpinner = this.stickyButton.querySelector('.loading__spinner');
            if (realSpinner && stickySpinner) {
                stickySpinner.classList.toggle('hidden', realSpinner.classList.contains('hidden'));
            }
        }
        
        setupPriceObserver() {
            if (!this.realPriceWrapper || !this.stickyPrice) return;
            this.stickyPrice.innerHTML = this.realPriceWrapper.innerHTML;
            
            this.priceObserver = new MutationObserver(() => {
                this.stickyPrice.innerHTML = this.realPriceWrapper.innerHTML;
            });
            this.priceObserver.observe(this.realPriceWrapper, {
                childList: true,
                subtree: true,
                characterData: true,
            });
        }
        
        disconnectedCallback() {
            this.visibilityObserver?.disconnect();
            this.stateObserver?.disconnect();
            this.priceObserver?.disconnect();
        }
    }
    
    customElements.define('sticky-add-to-cart', StickyAddToCart);
})();